<template>
	<div class="mapInfo">
		<div class="mapInfo-title">案卷详情</div>
		<el-carousel class="mapInfo-img" height="150px">
		     <el-carousel-item v-for="item in inanjuanData.reportPicture" :key="item"class="mapInfo-img">
		       <el-image :src="item"
		                 :preview-src-list="[item]" style="width: 100%;height: 100%;">
		       </el-image>
		     </el-carousel-item>
		   </el-carousel>

		<div>桥梁名称：{{inanjuanData.bridgeName}}</div>
		<div>上报人：{{inanjuanData.reportPeopleName}}</div>
		<div>状态：<span style="color: #1C9BB1;">{{inanjuanData.state==0?'待处理':inanjuanData.state==1?'已推送':'已完成'}}</span>
		</div>
		<div>
			病害类型：{{inanjuanData.problemType==0?'隔离栏':inanjuanData.problemType==1?'其他':inanjuanData.problemType==2?'护栏':inanjuanData.problemType==3?'桥梁':inanjuanData.problemType==4?'树围':inanjuanData.problemType==5?'井盖':inanjuanData.problemType==6?'沥青路面':inanjuanData.problemType==7?'道板':inanjuanData.problemType==8?'砼路面':inanjuanData.problemType==9?'石墩':inanjuanData.problemType==10?'缘石坡道':inanjuanData.problemType==11?'道路积水':inanjuanData.problemType==12?'花坛':inanjuanData.problemType==13?'道路开挖':'未填写类型'}}
		</div>
		<div>地址：{{inanjuanData.locationdDescribe}}</div>
		<div>时间：{{inanjuanData.reportTime}}</div>
	</div>
</template>

<script>
	export default {
		name: 'DeqingBridgeAndTunnelMapInfo',
		props: ['inanjuanData'],
		data() {
			return {

			};
		},

		mounted() {
		},

		methods: {
		},
	};
</script>

<style lang="scss" scoped>
	.mapInfo {
		width: 300px;
		// height: 351px;
		// background: rgba(25, 58, 127, 0.8);
		// border-radius: 10px;
		// border: 1px solid #33b4f0;
		font-size: 16px;
		font-family: SourceHanSansCN-Regular, SourceHanSansCN;
		font-weight: 400;
		color: #ffffff;

		.mapInfo-title {
			// width: 100%;
			background: #0d333a;
			border-radius: 9px 9px 0px 0px;
		}

		.mapInfo-img {
			width: calc(100% - 20px);
		}

		div {
			padding: 10px 0 10px 10px;
		}
	}
</style>
